import React, {useRef} from "react";
import PropTypes from "prop-types";
import {ErrorBoundary} from "react-error-boundary";
import {singleSelectQuestion} from "./questions/SingleSelect";
import {multiSelectQuestion} from "./questions/MultipleChoice";
import {textEntryQuestion} from "./questions/TextInput";
import RankingQuestion from "./questions/Ranking";
import * as icon from "./constants/iconConstants";
import * as display from "./constants/displayConstants";
import * as ddo from "./constants/customObjConstants";
import * as ssType from "./constants/singleSelectTypes";
import * as questionTypes from "./constants/questionTypeConstants";


// Replaced class-based PortalQuestionErrorBoundary with react-error-boundary's ErrorBoundary
const portalQuestionErrorHandler = (error, info) => {
    //TODO this should do something with the error
    console.log(error, info);// eslint-disable-line
};


function PortalQuestion(props) {
    const selfRef = useRef({props});
    selfRef.current.props = props;

    const formatAnswerInput = (likertIndex = 0, itemObj) => {
        const {group, question} = props;


        switch (question.questionType) {
            case questionTypes.FREE_TEXT:
                return textEntryQuestion.call(selfRef.current, question.questionType, "text", itemObj, props);
            case questionTypes.EMAIL:
                return textEntryQuestion.call(selfRef.current, question.questionType, "email", itemObj, props);
            case questionTypes.NUMBER:
            case questionTypes.CURRENCY:
            case questionTypes.PHONE:
            case questionTypes.ZIPPOSTAL_ONLY:
                return textEntryQuestion.call(selfRef.current, question.questionType, "number", itemObj, props);
            case questionTypes.DATE:
                return textEntryQuestion.call(selfRef.current, question.questionType, "date", itemObj, props);
            case questionTypes.DATE_RANGE:
                return textEntryQuestion.call(selfRef.current, question.questionType, "date-range", itemObj, props);
            case questionTypes.ADDRESS_FULL:
                return textEntryQuestion.call(selfRef.current, question.questionType, "text", itemObj, props);

            case questionTypes.CHECKBOX:
            case questionTypes.LIKERT_CHECKBOX:
                return multiSelectQuestion.call(selfRef.current, itemObj);

            case questionTypes.RANKING:{
                let answers = ddo.getAnswerOptions(question);

                if (answers.length > 0) {
                    return(
                        <RankingQuestion
                            textEntryType={question.questionType}
                            inputType={"ranking"}
                            itemObj={itemObj}
                            props={props}
                        />
                    )
                }
                break
            }

            case questionTypes.RADIO:
            case questionTypes.YES_NO:
            case questionTypes.LIKERT_RADIO: {

                let answers = ddo.getAnswerOptions(question);
                let displayAs = display.singleSelectDisplayAs(question, answers);

                if (answers.length !== 0) {
                    if ((question.questionType === questionTypes.LIKERT_RADIO) || (displayAs === ssType.SINGLE_SELECT_LIKERT)) {
                        answers = ddo.getAnswerOptions(((group !== undefined) && (group.answerOptionTemplates !== undefined) && (group.answerOptionTemplates.length > 0)) ? group : question);

                        // If a group LIKERT then get the itemObj for the current question
                        let itemObjQuestion = itemObj;
                        if (group !== undefined) {
                            for (let i = 0; i < itemObj.questions.length; i++) {
                                if (question.id === itemObj.questions[i].id) {
                                    itemObjQuestion = itemObj.questions[i];
                                    break;
                                }
                            }
                        }

                        return singleSelectQuestion.call(selfRef.current, ssType.SINGLE_SELECT_LIKERT, props, itemObjQuestion, false, icon.getLikertInputType(answers), likertIndex);
                    } else {
                        return singleSelectQuestion.call(selfRef.current, displayAs, props, itemObj, false);
                    }
                }
                break;
            }

            case questionTypes.STATE_ONLY:
                return singleSelectQuestion.call(selfRef.current, ssType.SINGLE_SELECT_DDLB_STATES, props, itemObj, false);

            default:
                return "";
        }
    };

    return (
        <ErrorBoundary onError={portalQuestionErrorHandler}>
            {formatAnswerInput(props.likertIndex, props.itemObj)}
        </ErrorBoundary>
    );
}


PortalQuestion.defaultProps = {
    showGroupKey: ""
};


PortalQuestion.propTypes = {
    //classes: PropTypes.object.isRequired,
    //theme: PropTypes.object.isRequired,
    questionnaire: PropTypes.object,
    group: PropTypes.object,
    showGroupKey: PropTypes.string,
    question: PropTypes.object.isRequired,
    questionNumber: PropTypes.string,
    itemObj: PropTypes.object.isRequired,
    answerQuestionOptions: PropTypes.func,
    answerQuestionTemplateOptions: PropTypes.func,
    onChangeQuestionText: PropTypes.func,
    answerQuestionText: PropTypes.func,
    answerQuestionTextInStore: PropTypes.func,
    likertIndex: PropTypes.number,
    displayMode: PropTypes.string,
    surveyEditMode: PropTypes.string
};

export default (PortalQuestion);

